var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.success
      ? _c("div", [
          _c("div", { staticClass: "field" }, [
            _c(
              "div",
              {
                staticClass: "control",
                class: { "is-loading": _vm.isLoading }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.code,
                      expression: "code"
                    }
                  ],
                  staticClass: "input",
                  attrs: {
                    type: "text",
                    placeholder: "Input your redeem code"
                  },
                  domProps: { value: _vm.code },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.code = $event.target.value
                    }
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "control",
              staticStyle: { "margin-bottom": "20px" }
            },
            [
              _c(
                "button",
                { staticClass: "button is-info", on: { click: _vm.submit } },
                [_vm._v("\n        Check Code\n      ")]
              )
            ]
          ),
          _vm._v(" "),
          _vm.evMessage
            ? _c("p", { staticClass: "has-text-danger" }, [
                _vm._v(_vm._s(_vm.evMessage))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.message
            ? _c("p", { staticClass: "has-text-danger" }, [
                _vm._v(_vm._s(_vm.message))
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.success
      ? _c("form", { attrs: { action: _vm.submitUrl, method: "POST" } }, [
          _c("input", {
            attrs: { name: "code", type: "hidden" },
            domProps: { value: _vm.code }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "_token" },
            domProps: { value: _vm.csrf }
          }),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "button is-success", on: { click: _vm.submit } },
            [_vm._v("\n      Get your ticket now!\n    ")]
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("p", [_vm._v("Success: click to get your ticket")])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }